module.exports = __webpack_public_path__ + "img/GrowthUser.93566a7c.svg";